// extracted by mini-css-extract-plugin
export const form = "bf_t";
export const dialog = "bf_b4";
export const input = "bf_g";
export const googleMapSection = "bf_cx";
export const fieldTitle = "bf_cy";
export const btnPin = "bf_cz";
export const positionSection = "bf_cB";
export const titleTxt = "bf_b5";